<template>
  <div class="panel panel-default">
    <facebook-logout-modal ref="modal" channel="Facebook" :credentials="credentials"></facebook-logout-modal>
    <div class="panel-heading">
      <span style="font-weight: 700" class="text-uppercase">FACEBOOK
        <span v-if="credentials.facebook_page_name">
        ({{ credentials.facebook_page_name }}
          <span v-if="credentials.facebook_page_category"> - {{ credentials.facebook_page_category }}</span>)
      </span>
      </span>
      <a v-if="credentials.facebook_token"><i class="fa fa-cog" aria-hidden="true" @click="openModal"
                                              content="Zugangsdaten bearbeiten" v-tippy></i></a>
      <a class="fa fa-question-circle" v-tippy
         content="Ihr Facebook Kanal muss ein geschäftlicher Kanal sein, es darf kein privat Account sein."></a>
      <div style="float:right">
          <span class="dot-red"
                v-if="!channels[index].foreign_id || (channels[index].publish_later && !isPast(channels[index].publish_at))"
                content="Entwurf" v-tippy></span>
        <span class="dot-green" v-else content="Ausgesendet" v-tippy></span>
      </div>
    </div>
    <div class="panel-body">
      <div
          v-if="isAuth()">
        <vue-toastr ref="toast"></vue-toastr>
        <label for="">Vorschaubild</label>
        <a class="fa fa-question-circle" v-tippy
           content="Die optimale Bildgröße liegt bei 1200 x 1200 Pixel. Die Datei darf 150 KB nicht überschreiten."></a>

        <content-preview :index="index" :content-prop="{url: channels[index].content_url, type: 'content'}"
                         :disabled="channels[index].foreign_id" :without-convert="true" @update:channels="channelsUpdated"></content-preview>
        <br>
        <div v-if="channels[index].foreign_id">
          <a :href="`https://facebook.com/${channels[index].foreign_id}`" target="_blank">Post öffnen</a>
        </div>
        <div class="ckeditor-wrapper">
          <label>Content</label>
          <ckeditor :editor="editor" v-model="channels[index].news_content" :config="editorConfig"></ckeditor>
        </div>
        <br>
        <!--        <div>-->
        <!--          <label for="link">Link</label>-->
        <!--          <input type="text" class="form-control" id="link" v-model="channels[index].facebook_link"-->
        <!--                 :disabled="channels[index].foreign_id">-->
        <!--        </div>-->
        <br>
        <div class="form-group">
          <input type="checkbox" :id="`publish_later${channels[index].id}`" v-model="channels[index].publish_later"
                 :disabled="channels[index].foreign_id && !channels[index].publish_later">
          <label :for="`publish_later${channels[index].id}`">Später veröffentlichen</label>
        </div>
        <div v-if="channels[index].publish_later" style="padding-bottom: 5px;">
          <label for="publish_at">Veröffentlichungsdatum</label>
          <input type="datetime-local" v-model="channels[index].publish_at" id="publish_at" class="form-control">
        </div>
      </div>
      <div v-if="!isAuth()">
        <facebook-login :index="index"></facebook-login>
      </div>
      <div>
        <button class="btn btn-sm btn-default" style="float:right" @click="deleteChannel"
                content="Aussendungskanal löschen" v-tippy>
          <i class="fa fa-trash-o" style="color: red"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import {mapGetters, mapMutations} from "vuex";
import Multiselect from "vue-multiselect";
import FacebookLogin from "../facebook/FacebookLogin";
import ContentPreview from "../image/ContentPreview";
import FacebookLogoutModal from "../modal/FacebookLogoutModal";
import {isPast} from "../../services/checkIfPast";

export default {
  name: 'Facebook',
  components: {FacebookLogoutModal, ContentPreview, FacebookLogin, VueToastr, Multiselect},
  props: ['context', 'index', 'newsHub'],
  data() {
    return {
      options: [],
      tagged_users: [],
      sendNotify: false,
      notifyCustomers: false,
      editorConfig: {
        instanceId: this.index,
        versionCheck: false,
        toolbar: [
          [
            'Undo',
            'Redo'
          ]
        ]
      }
    }
  },
  methods: {
    isPast,
    channelsUpdated() {
      this.$forceUpdate()
    },
    isAuth() {
      return this.credentials.facebook_token && this.credentials.facebook_page_access_token &&
          (this.credentials.facebook_token_expire_date * 1000) > Date.now()
    },
    openModal() {
      let element = this.$refs.modal.$el
      $(element).modal('show')
    },
    addTag(tag) {
      this.options.push(tag)
      this.channels[this.index].tagged_users.push(tag)
    },
    ...mapMutations(['getChannels', 'removeChannel', 'getChannelCredentials']),
    deleteChannel() {
      if (this.removeChannel({id: this.context.id, index: this.index})) {
        this.$refs.toast.s('Aussendungskanal gelöscht');
      }
    },
  },
  computed: {
    ...mapGetters({channels: 'getChannels', record: 'getRecord', credentials: 'getChannelCredentials'}),
  },
  mounted() {
    this.notifyCustomers = !!this.channels[this.index].notify_via
  }
}
</script>

<style scoped>
</style>
<style>
.ckeditor-wrapper-app .ck-content {
  min-height: 100px;
}
</style>
